export function faqToggle() {
    const faq = document.querySelector('.faq');
    if (!faq) return;

    const items = faq.querySelectorAll('.faq-item');

    items.forEach((item) => {
        const questionButton = item.querySelector('.faq-question');
        if (!questionButton) return;

        questionButton.addEventListener('click', () => {
            const isOpen = item.classList.contains('faq-item-open');
            item.classList.toggle('faq-item-open', !isOpen);
        });
    });
}
